"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Avatar = _interopRequireDefault(require("../../Clients/Avatar"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _CallIcon = _interopRequireDefault(require("../../../CallIcon"));
var _Dropdown = _interopRequireDefault(require("../../../Dropdown"));
var _Duration = _interopRequireDefault(require("../../../Duration"));
var _Name = _interopRequireDefault(require("../../Clients/Name"));
var _OrderStatus = _interopRequireDefault(require("../../Orders/OrderStatus"));
var _constants = require("../../Orders/OrderStatus/constants");
var _TicketType = _interopRequireWildcard(require("../../Tickets/TicketType"));
var _TimeFrom = _interopRequireDefault(require("../../Common/TimeFrom"));
var _Timer = _interopRequireDefault(require("../../../Timer"));
var _communication = require("../../../../icons-react/communication");
var _date = require("../../../../utils/date");
var _userflow = require("../../../../utils/userflow");
var _excluded = ["id"],
  _excluded2 = ["call", "contact", "onListen", "operator", "order", "ticket"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledDropdownContent = _Dropdown["default"].StyledContent;
var reasonText = ['причина', 'причины', 'причины'];
var Reason = function Reason(_ref) {
  var reason = _ref.reason;
  var description = reason.description,
    type = reason.type;
  return /*#__PURE__*/_react["default"].createElement(StyledReason, null, /*#__PURE__*/_react["default"].createElement(StyledReasonType, {
    title: type
  }, type), description && /*#__PURE__*/_react["default"].createElement(StyledReasonsDescription, {
    title: description
  }, description));
};
var reasonsContentRenderer = function reasonsContentRenderer(reasons) {
  return reasons.map(function (_ref2) {
    var id = _ref2.id,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
    return /*#__PURE__*/_react["default"].createElement(Reason, {
      key: id,
      reason: props
    });
  });
};
var reasonsHeadRenderer = function reasonsHeadRenderer(reasons) {
  var hiddenReasonsAmount = (0, _size2["default"])(reasons) - 1;
  return /*#__PURE__*/_react["default"].createElement(StyledReasons, null, /*#__PURE__*/_react["default"].createElement(Reason, {
    reason: reasons[0]
  }), /*#__PURE__*/_react["default"].createElement(StyledReasonsMore, null, "\u0415\u0449\u0435 ".concat(hiddenReasonsAmount, " ").concat((0, _userflow.pluralize)(hiddenReasonsAmount, reasonText))));
};
var CallCard = /*#__PURE__*/function (_React$PureComponent) {
  function CallCard(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CallCard);
    _this = _callSuper(this, CallCard, [props]);
    _this.handleListen = _this.handleListen.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(CallCard, _React$PureComponent);
  return (0, _createClass2["default"])(CallCard, [{
    key: "handleListen",
    value: function handleListen(event) {
      event.stopPropagation();
      var _this$props = this.props,
        call = _this$props.call,
        onListen = _this$props.onListen;
      var pbxId = call.pbxId;
      onListen({
        pbxId: pbxId
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        call = _this$props2.call,
        contact = _this$props2.contact,
        onListen = _this$props2.onListen,
        operator = _this$props2.operator,
        order = _this$props2.order,
        ticket = _this$props2.ticket,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded2);
      var answeredAt = call.answeredAt,
        callUrl = call.callUrl,
        finishedAt = call.finishedAt,
        isAnswered = call.isAnswered,
        isCallback = call.isCallback,
        isIncoming = call.isIncoming,
        isListen = call.isListen,
        isListenable = call.isListenable,
        pbxId = call.pbxId,
        reasons = call.reasons,
        recordUrl = call.recordUrl;
      var contactAvatarUrl = (0, _get2["default"])(contact, 'avatarUrl');
      var contactName = (0, _get2["default"])(contact, 'fullName');
      var operatorName = (0, _get2["default"])(operator, 'name');
      var operatorNumber = (0, _get2["default"])(operator, 'number');
      var orderHref = (0, _get2["default"])(order, 'href');
      var orderId = (0, _get2["default"])(order, 'id');
      var orderStatus = (0, _get2["default"])(order, 'status');
      var ticketSubtype = (0, _get2["default"])(ticket, 'subtype');
      var ticketType = (0, _get2["default"])(ticket, 'type');
      var reasonsAmount = (0, _size2["default"])(reasons);
      var singleReason = reasonsAmount === 1 ? reasons[0] : null;
      var duration = (0, _date.getCallDuration)(answeredAt, finishedAt);
      var isActive = !finishedAt;
      return /*#__PURE__*/_react["default"].createElement(StyledCallCard, props, /*#__PURE__*/_react["default"].createElement(StyledMainRow, null, /*#__PURE__*/_react["default"].createElement(StyledAvatar, {
        name: contactName,
        pulsing: isActive,
        url: contactAvatarUrl
      }), /*#__PURE__*/_react["default"].createElement(StyledDescription, null, contactName && /*#__PURE__*/_react["default"].createElement(StyledContactName, {
        name: contactName
      }), /*#__PURE__*/_react["default"].createElement(StyledCall, null, /*#__PURE__*/_react["default"].createElement(StyledCallIcon, {
        href: callUrl,
        isActive: isActive,
        isAnswered: isAnswered,
        isCallback: isCallback,
        isIncoming: isIncoming
      }), isActive && duration >= 0 && /*#__PURE__*/_react["default"].createElement(StyledTimer, {
        initialSeconds: duration
      }), !isActive && /*#__PURE__*/_react["default"].createElement(StyledDuration, {
        duration: duration
      }), recordUrl && /*#__PURE__*/_react["default"].createElement(StyledRecordLink, {
        href: recordUrl,
        target: "_blank",
        title: "\u041F\u0440\u043E\u0441\u043B\u0443\u0448\u0430\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C"
      }, /*#__PURE__*/_react["default"].createElement(StyledRecordIcon, null)), !isActive && finishedAt && /*#__PURE__*/_react["default"].createElement(StyledTimeFrom, {
        full: true,
        time: finishedAt
      })), operatorName && /*#__PURE__*/_react["default"].createElement(StyledOperator, null, /*#__PURE__*/_react["default"].createElement(StyledOperatorName, null, operatorName), operatorNumber && /*#__PURE__*/_react["default"].createElement(StyledOperatorNumber, null, operatorNumber))), pbxId && isListenable && isActive && /*#__PURE__*/_react["default"].createElement(StyledListenButton, {
        active: isListen,
        functional: true,
        onClick: this.handleListen
      }, /*#__PURE__*/_react["default"].createElement(StyledListenIcon, null))), ticketType && /*#__PURE__*/_react["default"].createElement(StyledTicketType, {
        subtype: ticketSubtype,
        type: ticketType
      }), orderId && orderHref && /*#__PURE__*/_react["default"].createElement(StyledOrderStatus, {
        href: orderHref,
        id: orderId,
        status: orderStatus
      }), reasonsAmount === 1 && /*#__PURE__*/_react["default"].createElement(Reason, {
        reason: singleReason
      }), reasonsAmount > 1 && /*#__PURE__*/_react["default"].createElement(StyledReasonsDropdown, {
        contentRenderer: reasonsContentRenderer(reasons),
        headRenderer: reasonsHeadRenderer(reasons)
      }));
    }
  }]);
}(_react["default"].PureComponent);
CallCard.propTypes = {
  className: _propTypes["default"].string,
  call: _propTypes["default"].shape({
    answeredAt: _propTypes["default"].number,
    callUrl: _propTypes["default"].string,
    finishedAt: _propTypes["default"].number,
    id: _propTypes["default"].string,
    isAnswered: _propTypes["default"].bool,
    isCallback: _propTypes["default"].bool,
    isIncoming: _propTypes["default"].bool,
    isListen: _propTypes["default"].bool,
    isListenable: _propTypes["default"].bool,
    pbxId: _propTypes["default"].string,
    recordUrl: _propTypes["default"].string,
    reasons: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      description: _propTypes["default"].string,
      id: _propTypes["default"].string.isRequired,
      type: _propTypes["default"].string.isRequired
    }).isRequired)
  }).isRequired,
  contact: _propTypes["default"].shape({
    avatarUrl: _propTypes["default"].string,
    fullName: _propTypes["default"].string
  }),
  onListen: _propTypes["default"].func,
  operator: _propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    number: _propTypes["default"].string
  }),
  order: _propTypes["default"].shape({
    href: _propTypes["default"].string.isRequired,
    id: _propTypes["default"].string.isRequired,
    status: _propTypes["default"].oneOf(Object.values(_constants.ORDER_STATUSES)).isRequired
  }),
  ticket: _propTypes["default"].shape({
    subtype: _propTypes["default"].oneOf(Object.values(_TicketType.SUBTYPES)),
    type: _propTypes["default"].oneOf(Object.values(_TicketType.TYPES)).isRequired
  })
};
CallCard.defaultProps = {
  className: '',
  contact: null,
  onListen: Function.prototype,
  operator: null,
  order: null,
  ticket: null
};
var StyledCallCard = _styledComponents["default"].div.withConfig({
  displayName: "CallCard__StyledCallCard",
  componentId: "sc-ymn6ja-0"
})(["border:1px solid #919499;border-radius:4px;box-sizing:border-box;color:#17181a;display:flex;flex-direction:column;height:133px;justify-content:space-between;padding:2px 10px 7px;position:relative;width:270px;"]);
var StyledMainRow = _styledComponents["default"].div.withConfig({
  displayName: "CallCard__StyledMainRow",
  componentId: "sc-ymn6ja-1"
})(["align-items:center;display:flex;height:53px;justify-content:space-between;"]);
var StyledAvatar = (0, _styledComponents["default"])(_Avatar["default"]).withConfig({
  displayName: "CallCard__StyledAvatar",
  componentId: "sc-ymn6ja-2"
})(["flex-shrink:0;margin-right:10px;margin-top:3px;z-index:1;"]);
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "CallCard__StyledDescription",
  componentId: "sc-ymn6ja-3"
})(["flex-grow:1;overflow:hidden;"]);
var StyledContactName = (0, _styledComponents["default"])(_Name["default"]).withConfig({
  displayName: "CallCard__StyledContactName",
  componentId: "sc-ymn6ja-4"
})(["font-size:14px;font-weight:bold;"]);
var StyledCall = _styledComponents["default"].div.withConfig({
  displayName: "CallCard__StyledCall",
  componentId: "sc-ymn6ja-5"
})(["align-items:center;color:#4d4d4d;display:flex;height:21px;"]);
var StyledCallIcon = (0, _styledComponents["default"])(_CallIcon["default"]).withConfig({
  displayName: "CallCard__StyledCallIcon",
  componentId: "sc-ymn6ja-6"
})(["height:17px;margin-right:4px;width:17px;"]);
var StyledTimer = (0, _styledComponents["default"])(_Timer["default"]).withConfig({
  displayName: "CallCard__StyledTimer",
  componentId: "sc-ymn6ja-7"
})(["flex-shrink:0;font-size:12px;font-weight:normal;margin-right:6px;min-width:31px;"]);
var StyledDuration = (0, _styledComponents["default"])(_Duration["default"]).withConfig({
  displayName: "CallCard__StyledDuration",
  componentId: "sc-ymn6ja-8"
})(["flex-shrink:0;margin-right:6px;min-width:31px;"]);
var StyledRecordLink = _styledComponents["default"].a.withConfig({
  displayName: "CallCard__StyledRecordLink",
  componentId: "sc-ymn6ja-9"
})(["flex-shrink:0;"]);
var StyledRecordIcon = (0, _styledComponents["default"])(_communication.Record).withConfig({
  displayName: "CallCard__StyledRecordIcon",
  componentId: "sc-ymn6ja-10"
})(["cursor:pointer;height:16px;margin-right:7px;margin-top:4px;width:16px;"]);
var StyledTimeFrom = (0, _styledComponents["default"])(_TimeFrom["default"]).withConfig({
  displayName: "CallCard__StyledTimeFrom",
  componentId: "sc-ymn6ja-11"
})(["flex-grow:1;white-space:nowrap;"]);
var StyledOperator = _styledComponents["default"].div.withConfig({
  displayName: "CallCard__StyledOperator",
  componentId: "sc-ymn6ja-12"
})(["color:#4d4d4d;display:flex;font-size:12px;"]);
var StyledOperatorName = _styledComponents["default"].div.withConfig({
  displayName: "CallCard__StyledOperatorName",
  componentId: "sc-ymn6ja-13"
})([""]);
var StyledOperatorNumber = _styledComponents["default"].div.withConfig({
  displayName: "CallCard__StyledOperatorNumber",
  componentId: "sc-ymn6ja-14"
})(["", " + &{:before{content:'\u22C5';margin:0 5px;}}"], StyledOperatorName);
var StyledListenButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "CallCard__StyledListenButton",
  componentId: "sc-ymn6ja-15"
})(["flex-shrink:0;height:17px;position:relative;width:15px;z-index:1;", ""], function (_ref3) {
  var active = _ref3.active;
  return active && "\n    svg path {\n      stroke: white;\n    }\n\n    &:after,\n    &:before {\n      animation: pulsing 1.5s infinite ease-in-out;\n      background-image: linear-gradient(to top, #00e04b, #00b0b6);\n      border-radius: 100%;\n      content: '';\n      left: 50%;\n      position: absolute;\n      top: 50%;\n      z-index: -1;\n    }\n    \n    &:after {\n      height: 22px;\n      margin-left: -12px;\n      margin-top: -11px;\n      opacity: 1;\n      width: 22px;\n    }\n\n    &:before {\n      height: 32px;\n      margin-left: -17px;\n      margin-top: -16px;\n      opacity: 0.3;\n      width: 32px;\n    }\n\n    @keyframes pulsing {\n      from { transform: scale(.8); }\n    }\n  ";
});
var StyledListenIcon = (0, _styledComponents["default"])(_communication.Listen).withConfig({
  displayName: "CallCard__StyledListenIcon",
  componentId: "sc-ymn6ja-16"
})(["width:15px;heigth:17px;"]);
var StyledTicketType = (0, _styledComponents["default"])(_TicketType["default"]).withConfig({
  displayName: "CallCard__StyledTicketType",
  componentId: "sc-ymn6ja-17"
})(["width:min-content;"]);
var StyledOrderStatus = (0, _styledComponents["default"])(_OrderStatus["default"]).withConfig({
  displayName: "CallCard__StyledOrderStatus",
  componentId: "sc-ymn6ja-18"
})(["font-size:12px;height:18px;line-height:18px;width:min-content;"]);
var StyledReason = _styledComponents["default"].div.withConfig({
  displayName: "CallCard__StyledReason",
  componentId: "sc-ymn6ja-19"
})(["color:#919499;display:flex;font-size:12px;overflow:hidden;text-align:left;> *{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}"]);
var StyledReasonType = _styledComponents["default"].div.withConfig({
  displayName: "CallCard__StyledReasonType",
  componentId: "sc-ymn6ja-20"
})(["color:black;font-weight:700;"]);
var StyledReasonsDescription = _styledComponents["default"].div.withConfig({
  displayName: "CallCard__StyledReasonsDescription",
  componentId: "sc-ymn6ja-21"
})(["", " + &{:before{content:'\u22C5';margin:0 5px;}}"], StyledReasonType);
var StyledReasonsDropdown = (0, _styledComponents["default"])(_Dropdown["default"]).withConfig({
  displayName: "CallCard__StyledReasonsDropdown",
  componentId: "sc-ymn6ja-22"
})(["background:none;border:none;font-family:inherit;position:relative;> button{outline:none;}", "{flex-direction:column;margin-top:0;padding:5px 10.5px;top:-5px;width:calc(100% + 22px);:before{display:none;}", "{padding-top:5px;white-space:normal;&:first-child{padding:0;}}}"], StyledDropdownContent, StyledReason);
var StyledReasons = _styledComponents["default"].div.withConfig({
  displayName: "CallCard__StyledReasons",
  componentId: "sc-ymn6ja-23"
})(["display:flex;font-size:12px;width:100%;"]);
var StyledReasonsMore = _styledComponents["default"].span.withConfig({
  displayName: "CallCard__StyledReasonsMore",
  componentId: "sc-ymn6ja-24"
})(["margin-left:10px;white-space:nowrap;"]);
var CallCardMemoized = /*#__PURE__*/_react["default"].memo(CallCard);
CallCardMemoized.ORDER_STATUSES = _constants.ORDER_STATUSES;
CallCardMemoized.TICKET_TYPES = _TicketType.TYPES;
CallCardMemoized.TICKET_SUBTYPES = _TicketType.SUBTYPES;
var _default = exports["default"] = CallCardMemoized;